import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const quickLinks = [
  { label: 'Inicio', to: '/', icon: 'ri-home-4-line' },
  { label: 'Servicios', to: '/servicios', icon: 'ri-tools-line' },
  { label: 'Compraventa', to: '/compraventa', icon: 'ri-car-line' },
  { label: 'Contacto', to: '/contacto', icon: 'ri-phone-line' },
];

export default function NotFound() {
  const location = useLocation();
  const [count, setCount] = useState(10);

  useEffect(() => {
    if (count <= 0) return;
    const t = setTimeout(() => setCount((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [count]);

  return (
    <div className="min-h-screen bg-zinc-950 flex flex-col">
      {/* Navbar minimal */}
      <header className="w-full px-6 md:px-10 h-16 flex items-center border-b border-zinc-900">
        <Link to="/" className="cursor-pointer">
          <img
            alt="Taller Kevin Alberto"
            className="h-8 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
            src="https://static.readdy.ai/image/ddfb463a64ca8c28bad8258e53257cac/7fa385eb80b3da87383713583b172ef6.png"
          />
        </Link>
      </header>

      {/* Main content */}
      <main className="flex-1 flex flex-col items-center justify-center px-6 relative overflow-hidden">
        {/* Background number */}
        <span
          aria-hidden="true"
          className="absolute inset-x-0 flex items-center justify-center text-[20rem] md:text-[28rem] font-black text-zinc-900 select-none pointer-events-none leading-none"
          style={{ top: '50%', transform: 'translateY(-50%)' }}
        >
          404
        </span>

        {/* Card */}
        <div className="relative z-10 text-center max-w-lg w-full">
          <div className="inline-flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/20 text-yellow-400 text-[10px] font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-6">
            <i className="ri-error-warning-line" />
            Página no encontrada
          </div>

          <h1 className="text-2xl md:text-3xl font-bold text-white mb-3 leading-tight">
            Vaya, esta página no existe
          </h1>
          <p className="text-zinc-500 text-sm mb-2 font-light">
            La ruta <code className="text-zinc-400 bg-zinc-900 px-2 py-0.5 rounded text-xs font-mono">{location.pathname}</code> no está disponible.
          </p>
          <p className="text-zinc-600 text-xs mb-10 font-light">
            Puede que el enlace esté roto o que la página haya sido movida.
          </p>

          {/* Quick links */}
          <div className="grid grid-cols-2 gap-3 mb-8">
            {quickLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="flex items-center gap-3 bg-zinc-900 hover:bg-zinc-800 border border-zinc-800 hover:border-yellow-400/30 text-zinc-400 hover:text-white text-sm font-medium px-4 py-3 rounded-lg transition-all duration-300 cursor-pointer"
              >
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                  <i className={`${link.icon} text-yellow-400 text-base`} />
                </div>
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA principal */}
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-yellow-400 text-black text-xs font-bold uppercase tracking-widest px-8 py-3.5 hover:bg-yellow-300 transition-all duration-300 whitespace-nowrap cursor-pointer rounded-md"
          >
            <i className="ri-arrow-left-line" />
            Volver al inicio
          </Link>

          {/* Whatsapp help */}
          <p className="mt-8 text-zinc-600 text-xs font-light">
            ¿Necesitas ayuda?{' '}
            <a
              href="https://wa.me/34666365922"
              target="_blank"
              rel="noopener noreferrer"
              className="text-emerald-500 hover:text-emerald-400 transition-colors cursor-pointer"
            >
              Escríbenos por WhatsApp
            </a>
          </p>
        </div>
      </main>
    </div>
  );
}
